// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15MRt","title":"styles_title__2CBWQ"};